const output = {
  content: ["required", "trim", "string"],
  isPublic: ["required", "boolean"],
};

export default output;
